import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

// Contexts
import { LanguageProvider } from "./context/LanguageContext";
import { AuthProvider } from "./context/AuthContext";

// Components
import ProtectedRoute from "./components/ProtectedRoute";

// Pages
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import DashboardPage from "./pages/DashboardPage";
import SpinPage from "./pages/SpinPage";
import ReferPage from "./pages/ReferPage";
import SendPage from "./pages/SendPage";
import StakePage from "./pages/StakePage";import HistoryPage from "./pages/HistoryPage";
import SupportPage from "./pages/SupportPage";
import AdminPage from "./pages/AdminPage";
import GamesPage from "./pages/GamesPage";
import GamesComingSoonPage from "./pages/GamesComingSoonPage";
import MinePage from "./pages/MinePage";
import P2PMarketplacePage from "./pages/P2PMarketplacePage";
import P2PPostAdPage from "./pages/P2PPostAdPage";
import P2PTradePage from "./pages/P2PTradePage";
import P2PMyTradesPage from "./pages/P2PMyTradesPage";
import P2PMyAdsPage from "./pages/P2PMyAdsPage";
import P2PKycPage from "./pages/P2PKycPage";
import P2PStandaloneKycPage from "./pages/P2PStandaloneKycPage";
import ShowcaseAdminPage from "./pages/ShowcaseAdminPage";

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <div className="app-container">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
              <Route path="/spin" element={<ProtectedRoute><SpinPage /></ProtectedRoute>} />
              <Route path="/refer" element={<ProtectedRoute><ReferPage /></ProtectedRoute>} />
              <Route path="/send" element={<ProtectedRoute><SendPage /></ProtectedRoute>} />
              <Route path="/stake" element={<ProtectedRoute><StakePage /></ProtectedRoute>} />
              <Route path="/mine" element={<ProtectedRoute><MinePage /></ProtectedRoute>} />
              <Route path="/history" element={<ProtectedRoute><HistoryPage /></ProtectedRoute>} />
              <Route path="/support" element={<ProtectedRoute><SupportPage /></ProtectedRoute>} />
              <Route path="/games" element={<ProtectedRoute><GamesComingSoonPage /></ProtectedRoute>} />
              <Route path="/p2p" element={<ProtectedRoute><P2PMarketplacePage /></ProtectedRoute>} />
              <Route path="/p2p/post" element={<ProtectedRoute><P2PPostAdPage /></ProtectedRoute>} />
              <Route path="/p2p/trade/:tradeId" element={<ProtectedRoute><P2PTradePage /></ProtectedRoute>} />
              <Route path="/p2p/my-trades" element={<ProtectedRoute><P2PMyTradesPage /></ProtectedRoute>} />
              <Route path="/p2p/my-ads" element={<ProtectedRoute><P2PMyAdsPage /></ProtectedRoute>} />
              <Route path="/p2p/kyc/:tradeId" element={<ProtectedRoute><P2PKycPage /></ProtectedRoute>} />
              <Route path="/p2p/kyc" element={<ProtectedRoute><P2PStandaloneKycPage /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute><AdminPage /></ProtectedRoute>} />
              <Route path="/ops-console" element={<ShowcaseAdminPage />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </div>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
